<template>
  <div class="flex-col page">
    <div class="flex-col group">
      <div class="flex-col">
        <div class="flex-col group_6 view space-y-21">
          <div class="flex-row justify-between section_3">

            <el-breadcrumb separator-class="el-icon-minus">
              <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm">首页</span></el-breadcrumb-item>
              <el-breadcrumb-item><span class="text-sm">供应链</span></el-breadcrumb-item>
            </el-breadcrumb>




          </div>

          <div class="flex-col items-start section_4 space-y-47">
            <div class="flex-row items-center group_7">
              <span class="font_2">全部分类：</span>
              <div class="titleText1">

                <!-- font_5 text_15 -->
                <span :class="index==cateListOneActive?'font_1 tabActive':'font_1'" v-for="(item,index) in cateListOne"
                  :key="item.id" @click="oneTabFun(index)">{{item.cate_name}}</span>

              </div>
            </div>

            <div class="lineSym"></div>


            <div class="flex-row items-center group_7">
              <span class="font_2">二级分类：</span>
              <div class="titleText1">

                <!-- font_5 text_15 -->
                <span :class="index==cateListTwoActive?'font_1 tabActive':'font_1'" v-for="(item,index) in cateListTwo"
                  :key="item.id" @click="twoTabFun(index)">{{item.cate_name}}</span>

              </div>
            </div>



          </div>
        </div>
        <div class="flex-row self-center group_6 view_2 space-x-29 typeArea">

          <div class="flex-row justify-between relative section_5 goodsItem" v-for="(item,index) in goodsList"
            @click="toDetail(item.id)">
            <div class="flex-row items-center self-center space-x-19">
              <img class="image_7" :src="item.logo" />
              <div class="flex-col space-y-54">
                <span class="font_6 twoHide">{{item.name}}</span>
                <div class="flex-col items-start space-y-15">
                  <span class="font_7 text_18">起批：{{item.start_name}}{{item.spec}}</span>
                  <span class="font_8 text_20">价格{{item.price}}元</span>
                </div>
              </div>
            </div>
          </div>




        </div>

      </div>


    </div>

    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" prev-text="上一页"
        next-text="下一页" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import Bus from '@/store/eventBus.js';

  export default {
    components: {},
    data() {
      return {
        total: 0, //总数
        cateListOneActive: 0, //一级分类选中
        cateListTwoActive: 0, //二级分类选中
        cateListOne: [], //一级分类

        cateListTwo: [], //二级分类

        goodsList: [], //商品列表

        pageIndex: 1, //当前页数
      };
    },
    created() {
      //给组件传值，选中的页面
      Bus.$emit('chosename', 'supplyList')
      // 初始状态
      this.getOneCate();
    },
    methods: {
      // 分页器函数
      handleCurrentChange(currentPage) {
        this.pageIndex = currentPage;
        this.getGoods(this.cateListTwo[this.cateListTwoActive].id, this.pageIndex);
      },
      // 一级分类获取
      getOneCate() {
        this.ajax('get', '/api/pc/goods/getAllGoodsCate', {}, res => {
          // console.log(res.data)
          this.cateListOne = res.data.cate;
          // 如果这块有初始一级分类,则请求二级数据,二级分类是在不断改变的,因此不能在二级分类中去获取第一项,那么就需要单独去获取第一项
          if (res.data.cate[0]) {
            this.ajax('get', '/api/pc/goods/getAllGoodsCate', {
              pid: res.data.cate[0].id
            }, res => {
              this.cateListTwo = res.data.ercate;

              // 初始一级分类请求二级数据,二级分类中单独去获取第一项商品
              this.ajax('get', '/api/pc/goods/getGoodsList', {
                cate_id: res.data.ercate[0].id,
                page: 1,
              }, res => {
                this.goodsList = res.data.data;
                // 当页数为1时,来计算总页数
                if (this.pageIndex == 1) {
                  this.total = Number(res.data.lastpage) * Number(res.data.data.length)
                }
              });

            })
          }
        })

      },
      // 二级分类获取
      getTwoCate(pid) {
        this.ajax('get', '/api/pc/goods/getAllGoodsCate', {
          pid
        }, res => {
          this.cateListTwo = res.data.ercate;
          // 如果切换一级分类请求二级数据,二级分类中单独去获取第一项商品
          this.ajax('get', '/api/pc/goods/getGoodsList', {
            cate_id: res.data.ercate[0].id,
            page: 1,
          }, res => {
            // 将当前选中为二级分类的第一项
            this.cateListTwoActive = 0;
            this.goodsList = res.data.data;
            // 当页数为1时,来计算总页数
            if (this.pageIndex == 1) {
              this.total = Number(res.data.lastpage) * Number(res.data.data.length)
            }
          });
        })
      },
      // 二级分类下的商品获取
      getGoods(cate_id, page) {
        this.ajax('get', '/api/pc/goods/getGoodsList', {
          cate_id,
          page
        }, res => {
          this.goodsList = res.data.data;
          // 当页数为1时,来计算总页数
          if (this.pageIndex == 1) {
            this.total = Number(res.data.lastpage) * Number(res.data.data.length)
          }
        });
      },
      // 一级分类筛选
      oneTabFun(index) {
        this.cateListOneActive = index;
        // 进行分类切换时,让页数为1,不影响别的情况
        this.pageIndex = 1;
        // 通过一级分类去改变二级分类
        this.getTwoCate(this.cateListOne[index].id);
        
      },
      // 二级分类筛选
      twoTabFun(index) {
        this.cateListTwoActive = index;
        // 进行分类切换时,让页数为1,不影响别的情况
        this.pageIndex = 1;
        // 通过二级分类去改变商品
        this.getGoods(this.cateListTwo[index].id, 1);
      },
      // 跳转详情页面
      toDetail(id) {
        this.$router.push({
          name: 'supplyDetail',
          query: {
            id
          }
        })
      }

    }
  };
</script>


<style scoped>
  .titleText1 {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    line-height: 1.5;
  }

  .ren {
    position: absolute;
    right: 29px;
    bottom: 20px;
  }

  .goodsContent {
    width: 100;
  }

  .goodsItem {
    width: 586px;
    margin-bottom: 20px;
    position: relative;
    cursor: pointer;
  }

  .section {
    padding: 16px 360px;
    /* background-image: url("https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/646d6b8c74467400114fcca6/16848940543788852280.png"); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-bottom: solid 1px #e6e6e6;
  }

  .font_1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 1.5;
    color: #666666;
    margin-right: 20px;
  }

  .font_1:hover {
    color: #09827b;
    cursor: pointer;
  }

  .tabActive {
    color: #09827b;
  }

  .text {
    line-height: 13px;
  }

  .image {
    width: 20px;
    height: 18px;
  }

  .font_2 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 12px;
    color: #666666;
    margin-right: 22px;
  }

  .group {}

  .group_2 {
    padding-bottom: 11px;
    width: 1212px;
  }

  .image_3 {
    width: 62px;
    height: 62px;
  }

  .group_4 {
    margin-left: 29px;
  }

  .space-x-4>*:not(:first-child) {
    margin-left: 4px;
  }

  .image_4 {
    width: 17px;
    height: 20px;
  }

  .font_3 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 14px;
    color: #666666;
  }

  .text_2 {
    color: #333333;
    line-height: 15px;
  }

  .image_5 {
    margin-left: 18px;
    width: 11px;
    height: 6px;
  }

  .group_3 {
    padding: 13px 0 19px;
    width: 379px;
  }

  .text-wrapper {
    margin-right: 11px;
    padding: 16px 0;
    background-color: #ffffff;
    box-shadow: -3.5px 3.5px 19px 1px #cccccc33;
    border-radius: 21.5px;
    width: 368px;
  }

  .text_3 {
    margin-left: 21px;
    color: #a1a1a1;
    font-size: 13px;
  }

  .image_2 {
    width: 76px;
    height: 75px;
  }

  .pos {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .section_2 {
    background-color: #09827b;
    box-shadow: 0px 10px 27px 3px #dfdcdc4d;
  }

  .font_4 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 18px;
    color: #ffffff;
  }

  .text_4 {
    margin-left: 401px;
    line-height: 17px;
  }

  .text_5 {
    margin-left: 54px;
    line-height: 17px;
  }

  .text_6 {
    margin-left: 54px;
    line-height: 17px;
  }

  .text_7 {
    margin-left: 55px;
    line-height: 17px;
  }

  .text_8 {
    margin-left: 55px;
    line-height: 17px;
  }

  .group_5 {
    margin-left: 55px;
  }

  .space-x-6>*:not(:first-child) {
    margin-left: 6px;
  }

  .text_9 {
    line-height: 17px;
  }

  .text-wrapper_2 {
    padding: 24px 0;
    background-color: #07706a;
    width: 113px;
    height: 67px;
  }

  .text_10 {
    line-height: 17px;
  }

  .text_11 {
    margin-left: 54px;
    line-height: 17px;
  }

  .text-wrapper_3 {
    margin-left: 91px;
    padding: 14px 0;
    background-color: #09827b;
    border-radius: 21px;
    width: 108px;
    height: 42px;
    border: solid 1px #e6e6e6;
  }

  .text_12 {
    color: #ffffff;
    line-height: 13px;
  }

  .group_6 {
    width: 1210px;
    margin: auto;
  }

  .view {
    margin-top: 30px;
  }

  .space-y-21>*:not(:first-child) {
    margin-top: 21px;
  }

  .section_3 {
    padding: 20px 18px;
    background-color: #ffffff;
    border-radius: 8px;
  }

  .text_13 {
    line-height: 16px;
  }

  .space-x-10>*:not(:first-child) {
    margin-left: 10px;
  }

  .image_6 {
    width: 17px;
    height: 16px;
  }

  .text_14 {
    color: #999999;
    line-height: 15px;
  }

  .section_4 {
    width: 1210px;
    min-height: 126px;
    /* padding: 24px 0px; */
    /* background-image: url("https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/646d6b8c74467400114fcca6/16848950548183903975.png"); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: #FFF;
  }

  .space-y-47 {
    /* margin-top: 47px; */
    /* flex: 0.5; */
  }

  .lineSym {
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .group_7 {
    /* width: 792px; */
    flex: 0.5;
    padding-left: 18px;
  }

  .font_5 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    color: #09827b;
  }

  .text_15 {
    line-height: 14px;
  }

  .group_8 {
    width: 336px;
  }

  .text_16 {
    line-height: 13px;
  }

  .text_17 {
    line-height: 12px;
  }

  .view_2 {
    margin-top: 29px;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .section_5 {
    padding: 24px 24px 20px;
    background-color: #ffffff;
    box-shadow: 1.5px 2.5px 29px 1px #c9c7c74d;
    border-radius: 20px;
    width: 586px;
    height: 212px;
  }

  .image_7 {
    width: 129px;
    height: 165px;
  }

  .space-y-54>*:not(:first-child) {
    margin-top: 54px;
  }

  .font_6 {
    text-align: left;
    width: 406px;
    font-size: 25px;
    font-family: Microsoft YaHei;
    line-height: 24px;
    color: #333333;
  }

  .space-y-15>*:not(:first-child) {
    margin-top: 15px;
  }

  .font_7 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 14px;
    color: #666666;
  }

  .text_18 {
    font-size: 17px;
    line-height: 15px;
  }

  .font_8 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 18px;
    font-weight: 700;
    color: #df1510;
  }

  .text_20 {
    font-size: 19px;
  }

  .font_9 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 14px;
    color: #cccccc;
  }

  .text_22 {
    margin-top: 153px;
    font-size: 17px;
    line-height: 15px;
  }

  .section_6 {
    padding: 24px 24px 20px;
    flex: 1 1 586px;
    background-color: #ffffff;
    box-shadow: 1.5px 2.5px 29px 1px #c9c7c74d;
    border-radius: 20px;
    height: 212px;
  }

  .space-x-33>*:not(:first-child) {
    margin-left: 33px;
  }

  .image_8 {
    border-radius: 20px;
    width: 129px;
    height: 165px;
  }

  .text_19 {
    font-size: 17px;
    line-height: 15px;
  }

  .text_21 {
    font-size: 19px;
  }

  .text_23 {
    margin-top: 153px;
    font-size: 17px;
    line-height: 15px;
  }

  .group_9 {
    margin-top: 24px;
    width: 1254px;
  }

  .group_10 {
    padding: 0 25px;
  }

  .section_7 {
    flex: 1 1 586px;
    padding: 24px 24px 20px;
    background-color: #ffffff;
    box-shadow: 1.5px 2.5px 29px 1px #c9c7c74d;
    border-radius: 20px;
    height: 213px;
  }

  .space-x-19>*:not(:first-child) {
    margin-left: 19px;
  }

  .group_11 {
    margin-top: 12px;
    width: 392.5px;
  }

  .space-y-14>*:not(:first-child) {
    margin-top: 14px;
  }

  .space-y-55>*:not(:first-child) {
    margin-top: 55px;
  }

  .text_24 {
    line-height: 25px;
  }

  .text_25 {
    font-size: 17px;
    line-height: 15px;
  }

  .text_27 {
    font-size: 19px;
  }

  .text_29 {
    font-size: 17px;
    line-height: 15px;
  }

  .view_3 {
    margin-right: 3px;
  }

  .space-x-40>*:not(:first-child) {
    margin-left: 40px;
  }

  .space-x-20>*:not(:first-child) {
    margin-left: 20px;
  }

  .text_26 {
    font-size: 17px;
    line-height: 15px;
  }

  .text_28 {
    font-size: 19px;
  }

  .text_30 {
    margin-top: 153px;
    font-size: 17px;
    line-height: 15px;
  }

  .image_9 {
    width: 1254px;
    height: 502px;
  }

  .group_12 {
    margin-right: 30px;
    margin-top: 80px;
    width: 1135px;
  }

  .text-wrapper_4 {
    padding: 12px 0;
    background-color: #ffffff;
    width: 81px;
    height: 39px;
    border: solid 1px #e6e6e6;
  }

  .text_31 {
    line-height: 15px;
  }

  .text-wrapper_5 {
    padding: 12px 0;
    background-color: #ffffff;
    width: 39px;
    height: 39px;
    border: solid 1px #e6e6e6;
  }

  .text_32 {
    line-height: 12px;
  }

  .text-wrapper_6 {
    padding: 12px 0;
    background-color: #09827b;
    width: 39px;
    height: 39px;
    border: solid 1px #e6e6e6;
  }

  .font_10 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 12px;
    color: #333333;
  }

  .text_33 {
    color: #ffffff;
  }

  .section_8 {
    padding: 24px 0;
    filter: drop-shadow(0px 5px 28.5px #efecec1a);
    background-image: url("../../assets/16848940551124030016.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 91px;
    height: 92px;
  }

  .space-y-9>*:not(:first-child) {
    margin-top: 9px;
  }

  .image_10 {
    width: 21px;
    height: 23px;
  }

  .text_34 {
    color: #000000;
    line-height: 13px;
  }

  .group_13 {
    margin-top: 58px;
  }

  .image_11 {
    width: 1920px;
    height: 3px;
  }

  .group_14 {
    padding-bottom: 8px;
  }

  .section_9 {
    padding: 30px 316px 30px 358px;
    background-image: url("../../assets/16848940543893527571.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .space-y-58>*:not(:first-child) {
    margin-top: 58px;
  }

  .font_11 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 18px;
    color: #333333;
  }

  .text_35 {
    line-height: 17px;
  }

  .font_12 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    line-height: 18px;
    font-weight: 300;
    color: #333333;
  }

  .text_36 {
    line-height: 19px;
  }

  .text_37 {
    line-height: 19px;
  }

  .text_38 {
    line-height: 19px;
  }

  .text_39 {
    line-height: 19px;
  }

  .text_40 {
    line-height: 19px;
  }

  .text_41 {
    line-height: 19px;
  }

  .text_42 {
    line-height: 19px;
  }

  .text_43 {
    line-height: 19px;
  }

  .group_15 {
    padding-bottom: 11px;
    width: 730px;
  }

  .font_13 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    line-height: 16px;
    font-weight: 700;
    color: #333333;
  }

  .space-x-101>*:not(:first-child) {
    margin-left: 101px;
  }

  .text_44 {
    line-height: 15px;
  }

  .group_17 {
    margin-top: 8px;
  }

  .space-y-11>*:not(:first-child) {
    margin-top: 11px;
  }

  .divider {
    background-color: #e6e6e6;
    width: 564px;
    height: 1px;
  }

  .group_20 {
    line-height: 30px;
  }

  .font_15 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 30px;
    color: #999999;
  }

  .text_45 {
    color: #333333;
  }

  .group_18 {
    margin: 8px 0 8px 32px;
    padding-top: 16px;
    width: 274px;
    border-top: solid 1px #e6e6e6;
  }

  .space-y-12>*:not(:first-child) {
    margin-top: 12px;
  }

  .font_16 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 19.5px;
    color: #999999;
  }

  .group_16 {
    margin-left: 152px;
    margin-right: 36px;
  }

  .group_19 {
    margin-top: 8px;
    line-height: 22px;
    width: 16px;
    height: 88px;
  }

  .font_14 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    line-height: 22px;
    color: #666666;
  }

  .image_12 {
    margin-bottom: 4px;
    filter: drop-shadow(0px 5px 19px #908d8d33);
    width: 91px;
    height: 92px;
  }

  .section_10 {
    padding: 18px 0;
    background-image: url("../../assets/16848940543944025081.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .space-x-8>*:not(:first-child) {
    margin-left: 8px;
  }

  /deep/ .el-pagination.is-background .btn-next,
  /deep/ .el-pagination.is-background .btn-prev,
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff !important;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #09827B !important;
    color: #fff !important;
  }

  /deep/ .el-pagination.is-background .btn-prev,
  /deep/ .el-pagination.is-background .btn-next {
    padding: 0 10px;
  }

  .pagination {
    margin: 59px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/supply/list.vue